.loadingProgress {
  width: 50px;
  margin: 5px auto;
  padding: 5px 0;
}
